
$(function(){

    function setSlideDirection() {

        // Change the direction the next slide when in first slide.
        if ($('.owl-stage > .owl-item').first().is('.active')) {
            direction = 'next';
        }

        // Change the direction the previous slide when in last slide.
        if ($('.owl-stage > .owl-item').last().is('.active')) {
            direction = 'prev';
        }
    }

});

// Visilabs

var sliderImages = [], sliderOffset = 250, sliderThrottle = 250, sliderPoll;

function isImageViewed(el){
    var coords = el.getBoundingClientRect();
    return ((coords.top >= 0 && coords.left >= 0 && coords.top) <= (window.innerHeight || document.documentElement.clientHeight) + parseInt(sliderOffset));
}

function pollSliderImages() {
    for (var i = sliderImages.length; i--;) {
        var self = sliderImages[i];
        if (isImageViewed(self)) {
            self.src = self.getAttribute('data-echo');
            sliderImages.splice(i, 1);
        }
    }
}

function _sliderThrottle() {
    clearTimeout(sliderPoll);
    sliderPoll = setTimeout(pollSliderImages, sliderThrottle);
}

function loadSliderImages(id) {
    var nodes = document.querySelectorAll(id+' [data-echo]');

    for (var i = 0; i < nodes.length; i++) {
        sliderImages.push(nodes[i]);
    }

    _sliderThrottle();

    if (document.addEventListener) {
        window.addEventListener('scroll', _sliderThrottle, false);
    } else {
        window.attachEvent('onscroll', _sliderThrottle);
    }
}

function swipeInOut(id) {
    jQuery(id).touchwipe({
        wipeLeft: function() {
            jQuery(id).carousel('next');
        },
        wipeRight: function() {
            jQuery(id).carousel('prev');
        },
        min_move_x: 20,
        min_move_y: 20,
        preventDefaultEvents: false
    });
}

function slideSearchProduct(code, arr){
    for (var i = 0; i < arr.length; i++){
        if (arr[i].code == code){
            return true;
        }
    }
    return false;
}

function generateSliderProductDetail (title, products, optionNumber){

    var slider_template_product_detail = $('' +
        '<div class="full-width recommendation-slider">' +
        '<div class="container recommendation-container">' +
        '<div class="row">' +
        '<div class="col-md-12">' +
        '<h4 class="orange-text recommended_header"></h4>' +
        '<div id="product_recommendation" class="owl-carousel">' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '');

    var slider = slider_template_product_detail.clone();

    slider.find('#product_recommendation').attr("id",'product-recommendation-' + optionNumber);
    slider.find('h4.recommended_header').text(title);

    var carousel_content = '';

    for (var i = 0; i < products.length; i++){

        carousel_content += '' +
            '<div class="item"> ' +
            '<div class="thumbnail">' +
            '<div style="min-height:138px">' +
                '<a href="'+products[i].dest_url+'">' +
                    '<img data-homeproductcat="'+optionNumber+'" data-name="'+products[i].title+'" data-echo="'+products[i].img+'" src="/images/ajax.gif" class="browseProductImage VisilabsRecommendation" alt="'+products[i].title+'" border="0">' +
                '</a>' +
            '</div>' +
            '<div class="caption">' +
            '<span style="display: block;font-size: 14px;margin-bottom:0;font-weight:300;margin-top:15px;max-height:40px;overflow-y:hidden;">' +
            '<a title="'+products[i].title+'" href="'+products[i].dest_url+'">'+products[i].title+'</a>' +
            '</span>' +
            '<div class="price-label">' +
            '<span class="PricebasePriceWithTax">'+products[i].price+' TL</span> <span class="PricesalesPrice">'+products[i].dprice+' TL</span>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
    }

    slider.find('#product-recommendation-' + optionNumber).append(carousel_content);

    $('#recommendations').append(slider);

    $('#product-recommendation-' + optionNumber).owlCarousel({
        items:4,
        slideBy:4,
        nav:true,
        loop: (products.length > 4),
        animateOut: 'fadeOut',
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:true,
        dots : false,
        scrollPerPage : true,
        navText: [
            "&nbsp;",
            "&nbsp;"
        ]
    });

    loadSliderImages('#product-recommendation-' + optionNumber);
}
